// ================================
// IMPORTS
// ================================
import type { App } from "vue"
import { registerSidebar } from "@core/layouts/sidebar-registry"
import BuildingSidebar from "@core/layouts/sidebars/BuildingSidebar.vue"
import SourceSidebar from "@core/layouts/sidebars/SourceSidebar.vue"
import UserSidebar from "@core/layouts/sidebars/UserSidebar.vue"

/**
 * Plugin d'enregistrement des sidebars (building, source, user).
 * Les modules pourraient enregistrer leurs sidebars dans leur install() si besoin.
 */
export default function sidebarRegistryPlugin(_app: App): void {
    registerSidebar("building", BuildingSidebar)
    registerSidebar("source", SourceSidebar)
    registerSidebar("user", UserSidebar)
}
